export class SafeError extends Error {}

export function isSafe(err: Error) {
  return err instanceof SafeError;
}

export function getSafeErrorMessage(err: Error) {
  return isSafe(err) ? err.message : 'There was an unknown error';
}
